module.exports = __webpack_public_path__ + "static/img/banner-es.43771243.png";